module.exports = __webpack_public_path__ + "static/media/coupon_without_instruction_title.0bd72adf.svg";